import { usePathname } from 'expo-router';

/**
 * Safely wraps `usePathname` from `expo-router`.
 *
 * Returns `null` when called outside an `expo-router` context.
 */
export const useSafePathname = () => {
  try {
    return usePathname();
  } catch {
    return null;
  }
};
